// @ts-check
import Vue from 'vue';
/**
 * @typedef {import('bto-models/betslip/search-user-model').default} SearchUserModel
 */

/**
 * Get default state for betslip messages
 */
const getDefaultState = () => ({
  /**
   * Assisted user info
   * @type {Partial<SearchUserModel>}
   */
  assistedUser: {},
});

export const assistedUserStore = Vue.observable(getDefaultState());

/**
 * Set the assisted bet user 
 * @param {SearchUserModel} user - assisted bet user
 */
export function setAssistedBetUser(user) {
  assistedUserStore.assistedUser = user;
}

/**
 * Remove assisted bet user
 */
export function removeAssistedBetUser() {
  assistedUserStore.assistedUser = {};
}